import { connect } from 'react-redux';
import get from 'lodash/get';
import { changeTickersInterval } from 'apex-web/lib/redux/actions/tickersActions';
import { selectedInstrumentSelector } from 'apex-web/lib/redux/selectors/instrumentPositionSelectors';
import { LightWeightChart } from 'apex-web/lib/components/LightWeightCharts/LightWeightChartContainer';

/**
 * Same wiring as apex-web RetailPriceChartContainer, but chartType is candlestick
 * (RetailPriceChartContainer hardcodes line).
 */
const mapStateToProps = state => {
  const selectedInstrument = selectedInstrumentSelector(state);
  return {
    chartType: 'candlestick',
    selectedInstrument,
    priceData: get(state, 'tickers.tickers', []),
    selectedInterval: state.tickers.interval,
    selectedInstrumentId: selectedInstrument.InstrumentId,
    hideVolume: true,
    hideIntervalButtons: true
  };
};

const mapDispatchToProps = {
  changeTickersInterval
};

export default connect(mapStateToProps, mapDispatchToProps)(LightWeightChart);
